<template>
    <div class="w-full header-shell text-zinc-900 dark:text-white">            <div class="grid grid-cols-[auto_1fr_auto] h-[56px] top_head_r relative">
            <div class="flex items-center h-full">
                <div class="px-4 cursor-pointer header-action h-full flex items-center" @click="clickHambuger">
                    <font-awesome-icon icon="fa-solid fa-bars" />
                </div>
                <div class="loader_content" v-if="isLoading">
                    <div class="custom-loader"></div>
                </div>
            </div>
            <div class="flex justify-center items-center h-full min-w-0">
                <h1 class="text-base md:text-lg lg:text-xl xl:text-2xl font-semibold truncate leading-tight m-0">{{ pageTitle }}</h1>
            </div>
            <div class="flex items-center justify-end gap-2 pr-3 h-full">
                <AsesorFilter
                  v-if="operadoresCargados.length && esPaginaOperaciones"
                  :operadores="operadoresCargados"
                  @change="onAsesorHeaderChange"
                  compact
                />
                <button
                    class="header-icon-btn"
                    @click="onToggleTheme"
                    :aria-label="`Cambiar a ${isDarkMode ? 'claro' : 'oscuro'}`"
                >
                    <i :class="[isDarkMode ? 'pi pi-sun' : 'pi pi-moon']"></i>
                </button>
                <Avatar class="header-avatar" :image="'/img/perfil/' + user +'.jpg'" style="background-color: #6366f1; color: #ffffff" 
                    shape="circle" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" />
                <Menu id="overlay_menu" ref="menu" :model="items" :popup="true" />
            </div>
        </div>

        <!-- Dialog cambiar contraseña -->
        <Dialog
            v-model:visible="passwordDialogVisible"
            header="Cambiar contraseña"
            :modal="true"
            :style="{ width: '380px' }"
            :closable="!guardandoPassword"
        >
            <div class="flex flex-col gap-4 pt-2">
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">Contraseña actual</label>
                    <Password
                        v-model="passwordForm.current"
                        :feedback="false"
                        placeholder="Ingresa tu contraseña actual"
                        class="w-full"
                        :inputStyle="{ width: '100%' }"
                    />
                </div>
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">Nueva contraseña</label>
                    <Password
                        v-model="passwordForm.newPass"
                        placeholder="Mínimo 6 caracteres"
                        class="w-full"
                        :inputStyle="{ width: '100%' }"
                        :minLength="6"
                    />
                </div>
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">Confirmar nueva contraseña</label>
                    <Password
                        v-model="passwordForm.confirm"
                        :feedback="false"
                        placeholder="Repite la nueva contraseña"
                        class="w-full"
                        :inputStyle="{ width: '100%' }"
                    />
                </div>
                <div v-if="passwordError" class="text-sm text-red-500 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg px-3 py-2">
                    <i class="pi pi-exclamation-triangle mr-1.5" style="font-size:0.75rem"></i>{{ passwordError }}
                </div>
            </div>
            <template #footer>
                <Button
                    label="Cancelar"
                    class="p-button-text"
                    :disabled="guardandoPassword"
                    @click="cerrarPasswordDialog"
                />
                <Button
                    label="Guardar"
                    :loading="guardandoPassword"
                    @click="cambiarPassword"
                />
            </template>
        </Dialog>
        <Toast position="bottom-center" />
    </div>
</template>

<script>
import { toggleTheme } from '../theme';
import AsesorFilter from '@/components/AsesorFilter.vue';
import axiosInstance from '@/axiosInstance';

export default {
    components: { AsesorFilter },
    name: 'Header',
    props: {
        isLoading: Boolean,
        dataOpenSideBar: Boolean,
        clickHambuger: Function
    },
    data() {
        return {
                    backPage: '',
                    currentPage: '',
                    username: '',
                    user: '',
                    isDarkMode: false,
                    operadoresCargados: [],
                    passwordDialogVisible: false,
                    guardandoPassword: false,
                    passwordError: '',
                    passwordForm: {
                        current: '',
                        newPass: '',
                        confirm: '',
                    },
    };
},
methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        }, 
        onToggleTheme() {
            const next = toggleTheme();
            this.isDarkMode = next === 'dark';
        },
        onAsesorHeaderChange() {
            // El store globalFilterStore maneja persistencia y notificación.
            // Las páginas reaccionan al CustomEvent 'gf:change'.
        },
        async cargarOperadores() {
            try {
                const res = await axiosInstance.get('/api/operators', {
                    params: { token: localStorage.getItem('token') },
                });
                if (res.status === 200) {
                    const data = res.data?.data || res.data;
                    if (data?.operators) {
                        this.operadoresCargados = data.operators;
                    }
                }
            } catch {
                // Silently fail - no operadores no rompe el header
            }
        },
        abrirPasswordDialog() {
            this.passwordError = '';
            this.passwordForm = { current: '', newPass: '', confirm: '' };
            this.passwordDialogVisible = true;
        },
        cerrarPasswordDialog() {
            this.passwordDialogVisible = false;
            this.passwordError = '';
            this.passwordForm = { current: '', newPass: '', confirm: '' };
        },
        async cambiarPassword() {
            this.passwordError = '';

            const { current, newPass, confirm } = this.passwordForm;

            if (!current || !newPass || !confirm) {
                this.passwordError = 'Todos los campos son obligatorios';
                return;
            }
            if (newPass.length < 6) {
                this.passwordError = 'La nueva contraseña debe tener al menos 6 caracteres';
                return;
            }
            if (newPass !== confirm) {
                this.passwordError = 'Las contraseñas nuevas no coinciden';
                return;
            }

            this.guardandoPassword = true;
            try {
                const res = await axiosInstance.post('/password', {
                    token: localStorage.getItem('token'),
                    previous_password: current,
                    password: newPass,
                    password_confirmation: confirm,
                });
                if (res.data.success || res.data.ok) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Contraseña actualizada',
                        detail: 'Tu contraseña se cambió correctamente',
                        life: 4000,
                    });
                    this.cerrarPasswordDialog();
                } else {
                    this.passwordError = res.data.message || res.data.msg || 'Error al cambiar contraseña';
                }
            } catch (e) {
                const msg = e?.response?.data?.message || e?.response?.data?.msg || 'Error de conexión al cambiar contraseña';
                this.passwordError = msg;
            } finally {
                this.guardandoPassword = false;
            }
        },
    },
    created() {
        this.currentPage = this.$route.name;
    },
    mounted() {
        if (localStorage.getItem('clientData') === null) {
            this.$router.push({ name: 'login' })
        } else { 
            const tokenId = JSON.parse(localStorage.getItem('clientData'));
            console.log('HEADER  ======================');
            console.log(tokenId);
            this.username = tokenId.name;
            this.user = tokenId.username;
        }
        this.isDarkMode = document.documentElement.classList.contains('dark');
        // Cargar operadores para el dropdown del header
        this.cargarOperadores();
    },
    computed: {
        pageTitle() {
            return this.$route.meta.title || '';
        },
        esPaginaOperaciones() {
            const ops = ['indicadores-op-kpi', 'indicadores-op-canales', 'indicadores-op-llamadas-minutas'];
            return ops.includes(this.$route.name);
        },
        items() {
            return [
                {
                    label: this.username || 'Usuario',
                    icon: 'pi pi-user',
                    disabled: true,
                    class: 'header-menu-user'
                },
                { separator: true },
                {
                    label: 'Cambiar contraseña',
                    icon: 'pi pi-key',
                    command: () => {
                        this.abrirPasswordDialog();
                    }
                },
                {
                    label: 'Cerrar Sesión',
                    icon: 'pi pi-sign-out',
                    command: () => {
                        localStorage.clear();
                        this.$router.push({ name: 'login' });
                    }
                }
            ];
        },
    },
    watch: {
        '$route'(to, from) {
            this.backPage = from.name;
            this.currentPage = to.name;
        }
    }
};

</script>

<style>
.top_head_r .loader_content {
    position: absolute;
    left: 50px;
}

.header-shell {
    background: var(--chrome-bg, #f3f4f6);
    border-bottom: 1px solid var(--chrome-border, rgba(148, 163, 184, 0.34));
}

.dark .header-shell {
    background: var(--chrome-bg, #18181b);
    border-bottom-color: var(--chrome-border, rgba(113, 113, 122, 0.52));
}

.header-action {
    transition: background-color 0.18s ease, color 0.18s ease;
}

.header-action:hover {
    background: rgba(148, 163, 184, 0.18);
}

.dark .header-action:hover {
    background: rgba(71, 85, 105, 0.44);
}

.header-icon-btn {
    width: 34px;
    height: 34px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(148, 163, 184, 0.45);
    background: rgba(255, 255, 255, 0.94);
    color: #475569;
    cursor: pointer;
    transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease;
    font-size: 0.82rem;
    flex-shrink: 0;
}

.header-icon-btn:hover {
    border-color: rgba(99, 102, 241, 0.5);
    background: rgba(239, 246, 255, 0.95);
    color: #4f46e5;
}

.dark .header-icon-btn {
    border-color: rgba(113, 113, 122, 0.48);
    background: rgba(24, 24, 27, 0.75);
    color: #d4d4d8;
}

.dark .header-icon-btn:hover {
    border-color: rgba(129, 140, 248, 0.5);
    background: rgba(30, 41, 59, 0.85);
    color: #a5b4fc;
}

.header-avatar {
    width: 32px !important;
    height: 32px !important;
    cursor: pointer;
    flex-shrink: 0;
    border: 1px solid rgba(148, 163, 184, 0.3);
    transition: border-color 0.18s ease, opacity 0.18s ease;
}

.header-avatar:hover {
    border-color: rgba(99, 102, 241, 0.5);
    opacity: 0.85;
}

.dark .header-avatar {
    border-color: rgba(113, 113, 122, 0.35);
}

.dark .header-avatar:hover {
    border-color: rgba(129, 140, 248, 0.45);
}

/* Reset h1 margins and ensure vertical centering */
.top_head_r h1 {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.25 !important;
}

/* Responsive: reducir contenido del header en pantallas pequeñas */
@media (max-width: 639px) {
  .header-shell .gap-2 {
    gap: 4px !important;
  }
  .header-shell .pr-3 {
    padding-right: 6px !important;
  }
}
</style>
